/**
 * Generate a secure random string using the browser crypto functions. Verifier must be between 43 and 128 chars long.
 */
const getCodeVerifier = () => {
    const array = new Uint32Array(28);
    crypto.getRandomValues(array);
    return Array.from(array, (dec) => `0${dec.toString(16)}`.slice(-2)).join('');
};

const getCodeChallenge = async (codeVerifier: string) => {
    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier));

    // Note: btoa is deprecated in Node.js, not for the web
    return btoa(String.fromCharCode(...new Uint8Array(digest)))
        .replace(/=/g, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '_');
};

/**
 * Calculate a code challenge and verifier, using the web crypto API, to be used as PKCE challenge params in an OAuth
 * process.
 */
export const getPkceChallenge = async () => {
    if (!crypto) {
        throw new Error('Cannot generate PKCE challenge params, crypto API is unavailable.');
    }

    const codeVerifier = getCodeVerifier();
    const codeChallenge = await getCodeChallenge(codeVerifier);

    return { codeChallenge, codeVerifier };
};
